import { render, staticRenderFns } from "./tennis-collect.vue?vue&type=template&id=f6b73d02&scoped=true&"
import script from "./tennis-collect.vue?vue&type=script&lang=js&"
export * from "./tennis-collect.vue?vue&type=script&lang=js&"
import style0 from "./tennis-collect.vue?vue&type=style&index=0&id=f6b73d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b73d02",
  null
  
)

export default component.exports